import merge from '../functions/merge'

export default {
	entity() {
		return merge({}, {
			label: '',
			type: 'quote',
			desc: '',
			ps: '',
			extra: '',
			storage: '',
			email: '',
			trans: {
				bank: 			'Bank',
				payment: 		'Betaling',
				page: 			'Side',
				description: 	'Beskrivelse',
				qty: 			'Antal',
				unit: 			'Enhed',
				vat: 			'Moms',
				discount: 		'Rabat',
				sur: 			'Tillæg',
				price: 			'Pris',

				total:			'Total',
				subtotal:		'Subtotal',
				hour:			'Timepris',
				var:			'Variable priser',
				ppu:			'Pris per enhed'
			},
			details: {
				title: '',
				subtitle: '',
				company: '',
				address: '',
				zip: '',
				city: '',
				vat: '',
				website: '',
				email: '',
				phone: '',
				bank: '',
				payment: '',
				footer: ''
			},
			incl_summary: true,
			incl_price: true,
			files: [],
			incl: '',
			ps_editable: false
		});
	},
	save(axios, entity) {
		var self = this;

		return new Promise(function (resolve) {
			if (entity.id) {
				axios
					.put('/templates/' + entity.id + '/', entity)
					.then(function (r) {
						resolve(merge(self.entity(), r.data));
					}, function () {
						
					});
			} else {
				axios
					.post('/templates/', entity)
					.then(function (r) {
						resolve(merge(self.entity(), r.data));
					}, function () {
						
					});
			}
		});
	},
	read(axios, id) {
		var self = this;

		return new Promise(function (resolve) {
			axios
				.get('/templates/' + id + '/')
				.then(function (r) {
					resolve(merge(self.entity(), r.data));
				}, function () {
					
				});
		});
	},
	delete(axios, id) {
		return new Promise(function (resolve) {
			axios
				.delete('/templates/' + id + '/')
				.then(function () {
					resolve(true);
				}, function () {
					
				});
		});
	}
};